/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Specification - Omobility app
 * OpenAPI documentation for Omobility app with Keycloak user authentication
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClientInquiry } from '../model';
/**
 * PublicInquiryControllerApi - axios parameter creator
 * @export
 */
export const PublicInquiryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Submit a new inquiry (Public)
         * @param {ClientInquiry} clientInquiry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (clientInquiry: ClientInquiry, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientInquiry' is not null or undefined
            assertParamExists('create', 'clientInquiry', clientInquiry)
            const localVarPath = `/api/v1/public/inquiry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OIDC_Authentication required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OIDC_Authentication", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientInquiry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicInquiryControllerApi - functional programming interface
 * @export
 */
export const PublicInquiryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicInquiryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Submit a new inquiry (Public)
         * @param {ClientInquiry} clientInquiry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(clientInquiry: ClientInquiry, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(clientInquiry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicInquiryControllerApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicInquiryControllerApi - factory interface
 * @export
 */
export const PublicInquiryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicInquiryControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Submit a new inquiry (Public)
         * @param {PublicInquiryControllerApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: PublicInquiryControllerApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.create(requestParameters.clientInquiry, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in PublicInquiryControllerApi.
 * @export
 * @interface PublicInquiryControllerApiCreateRequest
 */
export interface PublicInquiryControllerApiCreateRequest {
    /**
     * 
     * @type {ClientInquiry}
     * @memberof PublicInquiryControllerApiCreate
     */
    readonly clientInquiry: ClientInquiry
}

/**
 * PublicInquiryControllerApi - object-oriented interface
 * @export
 * @class PublicInquiryControllerApi
 * @extends {BaseAPI}
 */
export class PublicInquiryControllerApi extends BaseAPI {
    /**
     * 
     * @summary Submit a new inquiry (Public)
     * @param {PublicInquiryControllerApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicInquiryControllerApi
     */
    public create(requestParameters: PublicInquiryControllerApiCreateRequest, options?: RawAxiosRequestConfig) {
        return PublicInquiryControllerApiFp(this.configuration).create(requestParameters.clientInquiry, options).then((request) => request(this.axios, this.basePath));
    }
}

